<template>
  <div class="newMember">
    <v-card class="pa-10" flat>
      <v-card-title class="pa-0">
        更新會員
        <v-spacer></v-spacer>
        <div>
          <v-switch label="啟用" v-model="member.disabled" :true-value="0" :false-value="1"></v-switch>
        </div>
      </v-card-title>
      <v-divider class="mb-5"></v-divider>
      
      <v-row>
        <v-col>
          <v-subheader>暱稱</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="member.nickname"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>姓</v-subheader>
        </v-col>
        <v-col class="d-flex">
          <v-text-field 
            dense 
            v-model="member.last_name"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
          <v-subheader>名</v-subheader>
          <v-text-field 
            dense 
            v-model="member.first_name"
            :rules="[$rules.notEmpty]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>年齡</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="member.age"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>手機號碼</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="member.tel"
            :rules="[$rules.integer]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex">
          <v-subheader>密碼</v-subheader>
          <v-tooltip bottom nudge-right="120">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-2" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
            </template>
            <span>密碼長度須為 6 到 15 個字元，且包含英文字母及數字</span>
          </v-tooltip>
        </v-col>
        <v-col class="d-flex align-end">
          <v-text-field 
            dense 
            type="password"
            v-model="member.password"
            :rules="[$rules.password]"
            :disabled="!edit_password && updating"
          ></v-text-field>
          <v-checkbox
            v-if="updating" 
            class="ml-4"
            v-model="edit_password"
          ></v-checkbox>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col>
          <v-subheader>Email</v-subheader>
        </v-col>
        <v-col>
          <v-text-field 
            dense 
            v-model="member.email"
            :rules="[$rules.email]"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>是否通過身分認證</v-subheader>
        </v-col>
        <v-col>
          <v-checkbox  v-model="member.identity_verified"></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>桌布</v-subheader>
        </v-col>
        <v-col class="d-flex flex-wrap">
          <div 
            class="file-input mr-4" 
            @click="$refs[`wallpaper`].click()"
          >
            <v-icon class="delete" v-if="member.wallpaper" @click.stop="member.wallpaper = ''">
              fa-times-circle
            </v-icon>
            <div class="uploadText" v-if="!member.wallpaper">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              ref="wallpaper"
              :accept="$accept_file_type.image"
              v-if="!member.wallpaper" 
              onclick="this.value = null" 
              @change="uploadImage('wallpaper')"
            /> 
            <v-img v-if="member.wallpaper" :src="member.wallpaper.startsWith('data:') ? member.wallpaper : $HOST_URL + member.wallpaper"/>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-subheader>頭像</v-subheader>
        </v-col>
        <v-col class="d-flex flex-wrap">
          <div 
            class="file-input mr-4" 
            @click="$refs[`usericon`].click()"
          >
            <v-icon class="delete" v-if="member.usericon" @click.stop="member.usericon = ''">
              fa-times-circle
            </v-icon>
            <div class="uploadText" v-if="!member.usericon">
              <v-icon>fa-plus</v-icon>
              Select File
            </div>
            <input 
              type="file" 
              ref="usericon" 
              :accept="$accept_file_type.image"
              v-if="!member.usericon" 
              onclick="this.value = null" 
              @change="uploadImage('usericon')"
            /> 
            <v-img v-if="member.usericon" :src="member.usericon.startsWith('data:') ? member.usericon : $HOST_URL + member.usericon"/>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-6">
        <v-btn block dark color="indigo" @click="submit">送出</v-btn>
      </v-row>

    </v-card>
  </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      edit_password: false,
      member: {
        password: '',
        email: '',
        nickname: '',
        last_name: '',
        first_name: '',
        wallpaper: '',
        usericon: '',
        age: '',
        tel: '',
        identity_verified: false,
        disabled: false
      }
    }
  },
  created() {
    if(this.updating) {
      this.getMember()
    }
  },
  computed: {
    updating() {
      return this.$route.name == 'EditMember'
    },
    formIsValid() {
      return (
        this.$rules.notEmpty(this.member.last_name) &&
        this.$rules.notEmpty(this.member.first_name) &&
        this.updating ? (this.edit_password ? this.$rules.password(this.member.password) : true) : this.$rules.password(this.member.password) &&
        this.$rules.notEmpty(this.member.nickname) &&
        this.$rules.email(this.member.email) &&
        this.$rules.integer(this.member.tel) &&
        this.age ? this.$rules.integer(this.member.age) : true
      )
    },
  },
  methods: {
    async uploadImage(target) {
      let file = event.target.files[0]
      this.member[target] = await this.$func.fileToBase64(file)
    },
    getMember() {
      this.axios.get(`/admin/member/${this.$route.params.id}`).then(response => {
        this.member = response.data
      })
    },
    submit() {
      if(!this.formIsValid) {
        return
      }
      if(this.updating) {
        this.member.usericon = this.member.usericon && this.member.usericon.startsWith('data:') ? this.member.usericon : null
        this.member.wallpaper = this.member.wallpaper && this.member.wallpaper.startsWith('data:') ? this.member.wallpaper : null
        this.member.password = this.edit_password ? this.member.password : null
        this.axios.put(`/admin/member/${this.member.id}`, this.member).then(response => {
          this.$root.$emit('alert', 'success', '更新成功')
          this.$router.push('/admin/member')
        }).catch(() => {
          this.$root.$emit('alert', 'error', '更新失敗')
        })
      }
    }
  }
}
</script>

<style lang="scss">
.newMember {
  .row {
    align-items: center;
    & > div:first-child {
      flex-grow: 0;
      min-width: 140px;
    }
    & > div:nth-child(2) {
      max-width: 800px;
    }
  }
  .v-subheader {
    white-space: nowrap;
  }
}
</style>